import Header from './Heading';

export default Header;
